import { Observable, of } from 'rxjs';
import { catchError, filter, switchMap, take, tap } from 'rxjs/operators';
import { LoadDataFacade } from '../models';

export function checkStoreState(
  facade: LoadDataFacade,
  params?: unknown,
  skipLoad: boolean = false,
): Observable<boolean> {
  return facade.loaded$.pipe(
    tap((loaded: boolean) => {
      if (!loaded && !skipLoad) {
        facade.loadAll(params);
      }
    }),
    filter(Boolean),
    take(1),
    switchMap(() => of(true)),
    catchError(() => of(false)),
  );
}
